import { Injectable } from '@angular/core';
import { AbstractControlOptions, UntypedFormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { InvestmentKnowledge4 } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: InvestmentKnowledge4 & { riskProfil: any }) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<InvestmentKnowledge4 & { riskProfil: any }> = {
      ownerId: [entity.ownerId],
      userFirstName: [entity.userFirstName],
      userLastName: [entity.userLastName],

      riskProfil: this.formBuilder.group({
        scpi1: [entity?.riskProfil?.scpi1 || 'UNKNOWN'],
        scpi2: [entity?.riskProfil?.scpi2 || 'UNKNOWN'],
        scpi3: [entity?.riskProfil?.scpi3 || 'UNKNOWN'],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: InvestmentKnowledge4[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
